import { SupabaseClient, createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

// During static builds (e.g., in CI), environment variables for Supabase may not be set.
// Throwing at import time causes the build to fail even though the runtime
// environment will provide the variables. Instead, we lazily create the client
// if the variables are present; otherwise, we export a Proxy that throws only
// when one of its properties is accessed at runtime.

let supabase: SupabaseClient;

if (supabaseUrl && supabaseKey) {
  supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
      // Persist session in localStorage (default is true, but explicit is safer)
      persistSession: true,
      // Automatically refresh tokens before they expire
      autoRefreshToken: true,
      // Detect session from URL (for OAuth callbacks)
      detectSessionInUrl: true,
      // Storage key for the session
      storageKey: "chickytutor-auth",
      // Use localStorage for session persistence (more reliable than cookies for SPAs)
      storage: typeof window !== "undefined" ? window.localStorage : undefined,
    },
  });
} else {
  // Create a proxy that throws on any property access, surfacing a clear error
  // message at runtime while allowing the import to succeed during build.
  supabase = new Proxy({} as SupabaseClient, {
    get() {
      throw new Error(
        "Supabase environment variables are missing. Make sure NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY are set."
      );
    },
  });
}

export { supabase };
